import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://ektdsjbdniuofbmktjcb.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'sb_publishable_6TmlSOPF6LqO07PTjEn5hg_NwOsc8GL';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Tipos baseados no schema do banco
export interface DatabaseClient {
  id: string;
  name: string;
  logo: string;
  url?: string;
  description?: string;
  created_at: string;
  updated_at: string;
}

export interface DatabaseService {
  id: string;
  name: string;
  summary: string;
  starting_price?: string;
  created_at: string;
  updated_at: string;
}

export interface DatabaseProject {
  id: string;
  title: string;
  slug: string;
  client_id?: string;
  year: number;
  cover_image: string;
  summary: string;
  featured: boolean;
  visible?: boolean;
  created_at: string;
  updated_at: string;
}

export interface DatabaseTestimonial {
  id: string;
  name: string;
  role: string;
  company: string;
  quote: string;
  avatar: string;
  project_id?: string;
  created_at: string;
  updated_at: string;
}

export interface DatabaseProjectDiscipline {
  id: string;
  project_id: string;
  discipline: string;
  created_at: string;
}

export interface DatabaseProjectRole {
  id: string;
  project_id: string;
  role: string;
  created_at: string;
}

export interface DatabaseProjectTool {
  id: string;
  project_id: string;
  tool: string;
  created_at: string;
}

export interface DatabaseProjectColor {
  id: string;
  project_id: string;
  color: string;
  created_at: string;
}

export interface DatabaseProjectTypography {
  id: string;
  project_id: string;
  font: string;
  created_at: string;
}

export interface DatabaseProjectKPI {
  id: string;
  project_id: string;
  label: string;
  value: string;
  created_at: string;
}

export interface DatabaseProjectPress {
  id: string;
  project_id: string;
  outlet: string;
  url: string;
  created_at: string;
}

export interface DatabaseProjectGallery {
  id: string;
  project_id: string;
  src: string;
  alt: string;
  caption?: string;
  created_at: string;
}

export interface DatabaseProjectBeforeAfter {
  id: string;
  project_id: string;
  before_image: string;
  after_image: string;
  alt_text: string;
  created_at: string;
}

export interface DatabaseServiceDeliverable {
  id: string;
  service_id: string;
  deliverable: string;
  created_at: string;
}

export interface DatabaseServiceProcess {
  id: string;
  service_id: string;
  step: string;
  order_index: number;
  created_at: string;
}
